import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import productReducer from './productSlice';
import orderReducer from './orderSlice';
import cashSessionReducer from './cashSessionSlice';
import { authApi } from '../services/authApi';
import { productApi } from '../services/productApi';
import { orderApi } from '../services/orderApi';
import { customerApi } from '../services/customerApi';
import { paymentModeApi } from '../services/paymentModeApi';
import { carryBagApi } from '../services/carryBagApi';
import { salespersonApi } from '../services/salespersonApi';
import { cashSessionApi } from '../services/cashSessionApi';
import { discountApi } from '../services/discountApi';
import discountReducer from './discountSlice';
import giftVoucherSaleReducer from './giftVoucherSaleSlice';
import { promotionsApi } from '../services/promotionsApi';
import { returnApi } from '../services/returnApi';
import { exchangeApi } from '../services/exchangeApi';
import { orgSettingsApi } from '../services/orgSettingsApi';
import { whatsappApi } from '../services/whatsappApi';
import { posCouponApi } from '../services/posCouponApi';
import { denominationApi } from '../services/denominationApi';
import { inventoryApi } from '../services/inventoryApi';
import { categoryApi } from '../services/categoryApi';
import { receiptTemplateApi } from '../services/receiptTemplateApi';
import { customerWalletOtpApi } from '../services/customerWalletOtpApi';
import { giftVoucherApi } from '../services/giftVoucherApi';
import salesIncentivesReducer from './salesIncentivesSlice';
import { salesIncentivesApi } from '../services/salesIncentivesApi';
import { cashOfficeApi } from '../services/cashOfficeApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    productUI: productReducer,
    order: orderReducer,
    cashSession: cashSessionReducer,
    discount: discountReducer,
    giftVoucherSale: giftVoucherSaleReducer,
    salesIncentives: salesIncentivesReducer,
    [authApi.reducerPath]: authApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [paymentModeApi.reducerPath]: paymentModeApi.reducer,
    [carryBagApi.reducerPath]: carryBagApi.reducer,
    [salespersonApi.reducerPath]: salespersonApi.reducer,
    [cashSessionApi.reducerPath]: cashSessionApi.reducer,
    [discountApi.reducerPath]: discountApi.reducer,
    [promotionsApi.reducerPath]: promotionsApi.reducer,
    [returnApi.reducerPath]: returnApi.reducer,
    [exchangeApi.reducerPath]: exchangeApi.reducer,
    [orgSettingsApi.reducerPath]: orgSettingsApi.reducer,
    [whatsappApi.reducerPath]: whatsappApi.reducer,
    [posCouponApi.reducerPath]: posCouponApi.reducer,
    [denominationApi.reducerPath]: denominationApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [receiptTemplateApi.reducerPath]: receiptTemplateApi.reducer,
    [customerWalletOtpApi.reducerPath]: customerWalletOtpApi.reducer,
    [giftVoucherApi.reducerPath]: giftVoucherApi.reducer,
    [salesIncentivesApi.reducerPath]: salesIncentivesApi.reducer,
    [cashOfficeApi.reducerPath]: cashOfficeApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      productApi.middleware,
      orderApi.middleware,
      customerApi.middleware,
      paymentModeApi.middleware,
      carryBagApi.middleware,
      salespersonApi.middleware,
      cashSessionApi.middleware,
      discountApi.middleware,
      promotionsApi.middleware,
      returnApi.middleware,
      exchangeApi.middleware,
      orgSettingsApi.middleware,
      whatsappApi.middleware,
      posCouponApi.middleware,
      denominationApi.middleware,
      inventoryApi.middleware,
      categoryApi.middleware,
      receiptTemplateApi.middleware,
      customerWalletOtpApi.middleware,
      giftVoucherApi.middleware,
      salesIncentivesApi.middleware,
      cashOfficeApi.middleware,
    ),
});


export default store;
